<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-4 p-5">
        <!-- <tt-input-legacy label="Labour" [field]="model.labour_name" type="input" typevar="rbg" [optionfunc]="goToSelectLabour.bind(this)" glyphs="glyphicon-search"> </tt-input-legacy> -->

        <!-- <tt-input-legacy label="Location" [field]="model.stocklocation_name" type="input" typevar="rbg" [optionfunc]="goToSelectLocation.bind(this)" glyphs="glyphicon-search"> </tt-input-legacy> -->
        <tt-input ttLabel="Labour" [ttModel]="model.labour_name" (ttClick)="goToSelectLabour()" ttReadonly [ttButtons]="labourNameButtons"></tt-input>
        <tt-input ttLabel="Location" [ttModel]="model.stocklocation_name" (ttClick)="goToSelectLocation()" ttReadonly [ttButtons]="stockLocationButtons"></tt-input>
    </tt-card>

    <tt-list-legacy class="col-xs-12 col-md-12 p-5" [listItems]="model.plans" ltype="multi" [mconfig]="model.mconfig" designVar="s12t0" [optionfunc]="gridClick.bind(this)" typevar="g">
    </tt-list-legacy>
</tt-page>
